export const TOKEN_STORAGE_KEY = 'token';
export const COMPANY_STORAGE_KEY = 'company_name';

// Decode the payload segment of a JWT without verifying the signature.
// (Signature verification happens server-side; the client only needs the claims.)
const decodeJwt = (token) => {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(normalized)
        .split('')
        .map((char) => `%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join('')
    );
    return JSON.parse(json);
  } catch (error) {
    return null;
  }
};

export const getToken = () => localStorage.getItem(TOKEN_STORAGE_KEY);

export const getUser = () => {
  const token = getToken();
  return token ? decodeJwt(token) : null;
};

export const getCompanyName = () =>
  localStorage.getItem(COMPANY_STORAGE_KEY) || getUser()?.company_name || '';

export const isAuthenticated = () => {
  const user = getUser();
  if (!user) return false;

  // Treat an expired token as logged out.
  if (user.exp && Date.now() >= user.exp * 1000) {
    signOut();
    return false;
  }

  return true;
};

export const signIn = (token, companyName) => {
  localStorage.setItem(TOKEN_STORAGE_KEY, token);
  if (companyName) {
    localStorage.setItem(COMPANY_STORAGE_KEY, companyName);
  }
};

export const signOut = () => {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  localStorage.removeItem(COMPANY_STORAGE_KEY);
};
